const footerLinks = [
  {
    title: '追更导航',
    items: [
      { label: '话题标签', href: '#topics' },
      { label: '热门榜单', href: '#ranking' },
      { label: '最新更新', href: '#updates' },
      { label: '主题索引', href: '#index' },
    ],
  },
  {
    title: '特色服务',
    items: [
      { label: '追更优势', href: '#features' },
      { label: '热门推荐', href: '#cards' },
      { label: '移动追更', href: '#app' },
      { label: '常见问答', href: '#faq' },
    ],
  },
  {
    title: '关于我们',
    items: [
      { label: '关于韩漫屋', href: '#about' },
      { label: '联系我们', href: '#contact' },
      { label: '读者评论', href: '#comments' },
    ],
  },
];

export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <span className="text-xl font-heading font-bold text-primary-600">韩漫屋</span>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              韩漫追更平台，提供韩漫最新更新、韩漫连载更新提醒服务，免费追更最新章节，第一时间看最新韩漫章节。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-3">
                <a href="#" onClick={(e) => e.preventDefault()} className="no-underline text-foreground-900 hover:text-primary-600 transition-colors">
                  {group.title}
                </a>
              </h4>
              <ul className="space-y-2">
                {group.items.map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      onClick={(e) => handleClick(e, item.href)}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors no-underline"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 韩漫屋 - 韩漫追更平台. 本站内容仅供阅读参考.
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" onClick={(e) => handleClick(e, '#hero')} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors no-underline">首页</a>
              <a href="#about" onClick={(e) => handleClick(e, '#about')} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors no-underline">关于</a>
              <a href="#faq" onClick={(e) => handleClick(e, '#faq')} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors no-underline">帮助</a>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200/70">
          <h4 className="text-sm font-semibold text-foreground-900 mb-3">
            <a href="#" onClick={(e) => e.preventDefault()} className="no-underline text-foreground-900">合作伙伴</a>
          </h4>
          <p className="text-xs text-foreground-500">更多合作平台即将入驻，敬请期待。</p>
        </div>
      </div>
    </footer>
  );
}